module.exports = __webpack_public_path__ + "img/intel.e035ad31.svg";